import { Component, OnInit } from '@angular/core';
import { DashboardService } from '../dashboard.service';
import { forkJoin } from 'rxjs';

@Component({
  selector: 'app-general-balance-card',
  templateUrl: './general-balance-card.component.html',
  styleUrls: ['./general-balance-card.component.scss'],
})
export class GeneralBalanceCardComponent implements OnInit {
  public isLoaded: boolean = false;
  public generalAmount: number = 0;
  public blockedAmount: number = 0;

  constructor(private dashBoardService: DashboardService) {}

  ngOnInit(): void {
    this.loadBalances();
  }

  loadBalances(): void {
    this.isLoaded = true;

    forkJoin({
      generalBalance: this.getGeneralBalanceAmount(),
      blockedBalance: this.getBlockedBalanceAmount(),
    }).subscribe({
      next: (results) => {
        this.generalAmount = results.generalBalance;
        this.blockedAmount = results.blockedBalance;
      },
      error: (error) => {
        console.error('Erro ao carregar os saldos', error);
      },
      complete: () => {
        this.isLoaded = false;
      },
    });
  }

  getGeneralBalanceAmount() {
    return this.dashBoardService.getGeneralBalanceAmount().then((value) => {
      return value;
    });
  }

  getBlockedBalanceAmount() {
    return this.dashBoardService.getBlockedBalanceAmount().then((value) => {
      return value;
    });
  }
}
